// Fuel-availability icons rendered as SVG map images.
//
// Boss feedback 2026-05-10: bigger icons, and color them by REAL
// FUEL DYE COLOR so a glance at the badge matches the color the
// pilot sees in the fuel sample tube:
//   100LL Avgas  blue dye   (per FAA AC 20-24)
//   Jet-A        yellow / clear-yellow
//   Mogas        clear (no dye), kept mustard for visibility
//
//   fuel-100ll   blue circle   white 'L'
//   fuel-jeta    yellow circle dark   'J' (dark text for legibility)
//   fuel-mogas   mustard circle white 'M'
//
// One symbol layer per fuel type, filtered by the feature's
// fuelTypes array so an airport with both fuels renders BOTH icons
// offset slightly so both badges are visible.

import type { Map as MlMap } from 'maplibre-gl';
import { ensureSvgImages } from './iconRegistry';

// Bumped from 22 to 28 so the badge reads at the en-route zoom levels
// boss flies at. Inner circle pegs to the size for proportional
// scaling.
const SIZE = 28;
const CX = SIZE / 2;
const CY = SIZE / 2;
const R = 9;

const HALO = '#0b0d0f';
const TEXT = '#ffffff';

function svgFuel(fill: string, letter: string, textColor: string): string {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}">
      <circle cx="${CX}" cy="${CY}" r="${R}" fill="${HALO}"/>
      <circle cx="${CX}" cy="${CY}" r="${R - 1.6}" fill="${fill}"/>
      <text x="${CX}" y="${CY + 0.3}" text-anchor="middle" dominant-baseline="middle"
            font-family="Helvetica, Arial, sans-serif" font-weight="700"
            font-size="${SIZE * 0.52}" fill="${textColor}">${letter}</text>
    </svg>
  `;
}

// Real fuel-dye colors so the badge matches the sample tube:
//   100LL avgas  blue dye  (FAA AC 20-24)
//   Jet-A        yellow (clear-yellow tint)
//   Mogas        clear; kept mustard for visibility against chart
const SYMBOLS: Array<{ id: string; svg: string }> = [
  { id: 'fuel-100ll', svg: svgFuel('#2563eb', 'L', '#ffffff') }, // blue dye
  { id: 'fuel-jeta',  svg: svgFuel('#facc15', 'J', '#0b0d0f') }, // yellow (dark text for legibility)
  { id: 'fuel-mogas', svg: svgFuel('#ca8a04', 'M', '#ffffff') }, // mustard
];

export const FUEL_LEGEND_SVGS = {
  '100LL':  svgFuel('#2563eb', 'L', '#ffffff'),
  'JetA':   svgFuel('#facc15', 'J', '#0b0d0f'),
  'Mogas':  svgFuel('#ca8a04', 'M', '#ffffff'),
};

export function ensureFuelIcons(map: MlMap): Promise<void> {
  return ensureSvgImages(map, SYMBOLS, {
    defaultSize: SIZE,
    logTag: '[fuelIcons]',
  });
}
